import { formValueSelector } from 'redux-form'

import { REDUCER_NAME, FORM_NAME } from './constants'

const formSelector = formValueSelector(FORM_NAME)

export const getFormField = (state, field) => formSelector(state, field)
export const isLoading = (state) => state[REDUCER_NAME].fetching
export const getOfficerList = (state) => state[REDUCER_NAME].officers
export const getError = (state) => state[REDUCER_NAME].error
